import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router';

import LangSwitch from '../../../../shared/lang/switch';
import InputField from '../../../../shared/form-elements/input';
import SelectField from '../../../../shared/form-elements/select/field';
import UploadField from '../../../../shared/form-elements/upload';
import TextField from '../../../../shared/form-elements/textarea';

const getTranslationFieldName = lang => lang !== 'en' ? `translations.${lang}.` : '';

const translationSwitcher = (lang, intl) => (
	<div>
		<div className='ui-form__element'>
			<Field
				name={`${getTranslationFieldName(lang)}name`}
				placeholder={intl('Name')}
				component={InputField}
			/>
		</div>
		<div className='ui-form__element'>
			<Field
				name={`${getTranslationFieldName(lang)}description`}
				placeholder={intl('Description')}
				component={TextField}
			/>
		</div>
	</div>
);

const Main = props => {
	return (
		<div className='bm-accounts-form-wrap'>
			<div className='bm-accounts-form-wrap__langs'>
				<LangSwitch
					langs={props.mainTabLangs}
					onChangeLang={props.mainFormChangeLanguage}
				/>
			</div>
			<form
				onSubmit={props.handleSubmit(props.mainFormSubmit)}
				className='ui-form bm-accounts-form__main clearfix'
			>
				<div className='bm-accounts-form__main-fields'>
					{(translationSwitcher(props.currentLanguage, props.intl))}
					<div className='selectors-wrapper'>
						<div className='ui-form__element price'>
							<Field
								name='price'
								type='number'
								placeholder={props.intl('Price')}
								component={InputField}
							/>
						</div>
						<div className='ui-form__element currency'>
							<Field
								name='currency'
								placeholder={props.intl('Currency')}
								component={SelectField}
								searchable={false}
								clearable={false}
								multi={false}
								options={props.currencyOptions}
							/>
						</div>
					</div>
					<div className='ui-form__element price'>
						<Field
							name='category'
							placeholder={props.intl('Category')}
							component={SelectField}
							searchable={false}
							clearable={false}
							multi={false}
							options={props.bmCategoriesLookup}
						/>
					</div>
					<div className='ui-form__element price'>
						<Field
							name='available_amount'
							type='number'
							placeholder={props.intl('Available amount')}
							component={InputField}
						/>
					</div>
				</div>
				<div className='bm-accounts-form__main-meta'>
					<div className='ui-form__element'>
						<Field
							name='image'
							component={UploadField}
							placeholder={props.intl('Upload')}
							preparationFile={props.preparationFile}
						/>
					</div>
				</div>
				<div className='accounts-form__footer'>
					<div className='ui-form__element buttons-wrap'>
						{props.can('edit') && (
							<button className='ui-btn ui-btn-primary'>
								{props.intl(props.data.id ? 'Update' : 'Save')}
							</button>
						)}
						<Link
							to='/bm-accounts'
							className='ui-btn ui-btn-cancel'
						>{props.intl('Cancel')}</Link>
					</div>
				</div>
			</form>
		</div>
	);
};

Main.propTypes = {
	handleSubmit: PropTypes.func,
	mainFormSubmit: PropTypes.func,
	mainTabLangs: PropTypes.array,
	mainFormChangeLanguage: PropTypes.func,
	intl: PropTypes.func,
	preparationFile: PropTypes.func,
	data: PropTypes.object,
	can: PropTypes.func,
	currentLanguage: PropTypes.string
};

export default reduxForm({
	form: 'bmAccountsMainForm'
})(Main);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/bm-accounts/components/forms/general/main.js